module.exports = __webpack_public_path__ + "static/img/quanmin_qmqb1.60dc9ad9.png";